import { createRouter } from '@tanstack/react-router';
import { NotFoundPage, RouteErrorPage, RoutePending } from './components/ui/route-states';
import { routeTree } from './routeTree.gen';
import { createQueryClient } from './lib/query-client';
import { sessionQueryOptions } from './lib/session';
import { watchSessionExpiry } from './lib/session-expiry';
import { applySubdomainRewrite } from './utils/subdomain';

export const queryClient = createQueryClient();

// A 401 only means "session ended" for someone who was signed in: the cached session says whether they were.
watchSessionExpiry(() => !!queryClient.getQueryData(sessionQueryOptions.queryKey));

export const router = createRouter({
  routeTree,
  rewrite: applySubdomainRewrite,
  defaultPreload: 'intent',
  defaultNotFoundComponent: NotFoundPage,
  defaultErrorComponent: RouteErrorPage,
  defaultPendingComponent: RoutePending,
  context: { queryClient },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    /** The staff shell gives this page the wider Settings canvas (Figma A16: 1200 instead of 1136). */
    wide?: boolean;
    /** The staff shell gives this page the My work board's 44px gutters (Figma A05.7: 1280 across at 1440) instead of 84. */
    board?: boolean;
  }
}
